/*
  File name: index.js
    Program Description:
    - This file sets the values for the alert state.
*/

const state = {
  alert: {
    type: 'success',
    show: false,
    message: '',
    callback: null,
    list: null,
    email: null
  },
  alerts: []
}

const mutations = {
  appendAlert (state, payload) {
    state.alerts.push(payload)
  },
  setAlert (state, { message, type, callback, list, email }) {
    state.alert.message = message
    state.alert.show = true
    state.alert.type = type
    state.alert.callback = callback
    state.alert.list = list
    state.alert.email = email
  }
}

const getters = {
  getAlert: state => state.alert,
  getAlerts: state => state.alerts
}

const actions = {
  showAlert ({ state, commit, dispatch }, { message, type, callback, override, list, email }) {
    if (override) {
      state.alerts.length = 0
      state.alert.show = false
    }
    commit('appendAlert', { message, type, callback, list, email })

    state.alert.show || dispatch('show')
  },

  show ({ state, commit }) {
    if (state.alerts.length) {
      commit('setAlert', state.alerts.shift())
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
